<template>
    <div class="sticky-header">
        <div class="company-name td-flex">
            {{editLocation.name}}&nbsp;
           <listing-status :selected-site="selectedSite" :edit-state="editState" :is-admin="isAdmin"></listing-status>
        </div>

        <div class="edit-btns">
            <button v-if="(editState || hoursState) && isAdmin" @click.prevent="openAccountMove" class="td-btn icon-left slim default"><icon name="faUserPen" type="solid"></icon> Move</button>
            <button v-if="editState || hoursState" @click.prevent="openEdit('general')" class="td-btn icon-left slim primary"><icon name="faPen" type="solid"></icon> General Info</button>
            <button v-if="editState || hoursState" @click.prevent="openEdit('marketing')" class="td-btn icon-left slim primary"><icon name="faPen" type="solid"></icon> Marketing Info</button>
            <button v-if="editState" @click.prevent="showManageHours" class="td-btn icon-left slim primary"><icon name="faPen" type="solid"></icon> Hours</button>
        </div>
    </div>

</template>

<script>
    import script from './EditHeader';
    export default script;</script>